import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  languageSelect: {
    display: 'inline-flex',
    position: 'relative',
    alignItems: 'center',
    '> span': {
      fontSize: theme.fontSizes.text
    },
    '> * + *': {
      marginLeft: '8px'
    },
    button: {
      margin: '0px'
    }
  },
  languageSelectIcon: {
    pb: '0px',
    ml: 0
  },
  languageSelectTextWrapper: {
    display: 'inline-flex',
    alignItems: 'baseline',
    '> * + *': {
      marginLeft: '8px'
    }
  },
  expandMoreIcon: (dropdownOpened: boolean) => ({
    'span.icon': {
      transform: dropdownOpened && 'rotate(180deg)'
    }
  }),
  languageSelectUnderlineText: {
    textDecoration: 'underline',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    fontSize: theme.fontSizes.text,
    border: 'none',
    backgroundColor: 'transparent',
    ml: '8px'
  },
  sidebarContent: {
    height: ['calc(100% - 105px)', 'calc(100% - 105px)', 'calc(100% - 105px)', 'calc(100% - 105px)', 'calc(100% - 105px)', 'calc(100% - 148px)'],
    width: '100%',
    flexDirection: 'column',
    flexShrink: 0,
    marginLeft: 'auto',
    background: theme.background.sideBar
  },
  sidebarHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: ['16px', '16px', '16px  24px', '16px  24px', '16px 24px', '38px 40px'],
    flexShrink: 0,
    borderBottom: `1px solid ${theme.rawColors.lightGrey300}`
  },
  sidebarQuantity: {
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.h4,
    paddingLeft: '8px'
  },
  sidebarMainContent: {
    flexGrow: 1,
    padding: ['16px 12px 8px 8px', '16px 12px 8px 8px', '16px', '16px', '24px'],
    m: ['8px', '8px', '8px', '8px', '16px'],
    height: '100%',
    overflow: 'hidden',
    overflowY: 'auto',
    ...reusables.scrollbar()
  },
  sidebarListWrapper: {
    p: ['8px 0', '8px 0', '8px 0', '8px 0', '24px 0'],
    listStyleType: 'none'
  },
  countryListItem: {
    borderBottom: `solid 1px ${theme.rawColors.lightGrey300}`,
    color: theme.rawColors.darkGrey700
  },
  regionButton: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    border: 'none',
    backgroundColor: 'transparent',
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.text,
    lineHeight: '140%',
    padding: '16px 0 16px 0'
  },
  languageListWrapper: {
    display: 'flex',
    flexDirection: 'column'
  },
  buttonText: {
    display: 'flex',
    alignItems: 'center'
  },
  buttonIcon: {
    ml: '12px'
  },
  languageListItem: (selected: boolean) => ({
    bg: 'transparent',
    border: 'none',
    display: 'block',
    textAlign: 'left',
    width: '100%',
    textDecoration: selected ? 'underline' : 'none',
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.smallText,
    color: theme.rawColors.darkGrey700,
    textTransform: 'capitalize',
    pb: '12px',
    lineHeight: '140%',
    '&:hover': {
      textDecoration: `underline`
    }
  }),
  dropdown: (isActive: boolean) => ({
    minWidth: '89px',
    background: theme.rawColors.neutralWhite,
    position: 'absolute',
    bottom: '40px',
    right: 0,
    border: `1px solid ${theme.rawColors.lightGrey700}`,
    zIndex: theme.zIndex.documentHigh,
    opacity: isActive ? 1 : 0,
    display: isActive ? 'block' : 'none',
    ...reusables.mainTransition('opacity')
  }),
  languageDropdown: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  dropdownListItem: {
    bg: 'transparent',
    border: 'none',
    display: 'block',
    textAlign: 'left',
    width: '100%',
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.smallText,
    color: theme.rawColors.darkGrey700,
    textTransform: 'capitalize',
    lineHeight: '140%',
    padding: '6px 12px 6px 12px',
    '&:hover': {
      background: theme.rawColors.lightGrey400
    }
  }
};